import { render } from "./PracticeProductCard.vue?vue&type=template&id=311db148&scoped=true"
import script from "./PracticeProductCard.vue?vue&type=script&lang=js"
export * from "./PracticeProductCard.vue?vue&type=script&lang=js"

import "./PracticeProductCard.vue?vue&type=style&index=0&id=311db148&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311db148"]])

export default __exports__